function StopIcon(props) {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x={2} width={4} height={16} rx={1} fill="#fff" />
      <rect x={11} width={4} height={16} rx={1} fill="#fff" />
    </svg>
  );
}

export default StopIcon;
